import request from '@/utils/request';
export function questionnaireRecordList(data) {
  return request.post('admin/questionnaire/record', data);
}
// 审核进度
export function auditSchedule(data) {
  return request.post('admin/audit-record/schedule', data);
}

// 审核详情
export function auditDetail(data) {
  return request.post('admin/audit-record/detail', data);
}